var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-shell"},[_c('site-header',{attrs:{"company-info":_vm.companyInfo}}),_c('main',[_c('router-view',{attrs:{"company-info":_vm.companyInfo}})],1),_c('site-footer',{attrs:{"company-info":_vm.companyInfo}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }